import { CURRENT_GAME_FIELD, DESIRED_GAME_FIELD, PLAYER_ID_FIELD, USERNAME_FIELD } from "../../framework/firebase/DBPathConstants";
import { Layer } from "../../framework/layer/Layer";
import { DataListener } from "../../framework/layer/DataListener";
import { DataProvider } from "../../framework/layer/DataProvider";
import { UserIdFirebaseWrapper } from "../../framework/firebase/UserIdFirebaseWrapper";
const USER_FIELDS = [PLAYER_ID_FIELD, DESIRED_GAME_FIELD, CURRENT_GAME_FIELD, USERNAME_FIELD];
export class UserDataListener extends DataListener {
    constructor(firebase, userIdProvider) {
        super({
            firebase,
            listen: {
                paths: USER_FIELDS,
            },
            keyMapping: (input) => input.split('/').at(-1),
        });
        this.userIdProvider = userIdProvider;
    }
    activate() {
        const userId = this.userIdProvider.data.userId;
        this.config.firebase = new UserIdFirebaseWrapper(this.config.firebase, userId);
        super.activate();
    }
}
export class UserDataProvider extends DataProvider {
    constructor(dataListener) {
        super(dataListener, USER_FIELDS);
    }
    // TODO: Maybe this should only activate if currentGame = desiredGame. Layer doesn't offer a mechanism for this kind of condition yet.
    canActivate() {
        const data = this.data;
        return super.canActivate() && this.data[CURRENT_GAME_FIELD] === this.data[DESIRED_GAME_FIELD];
    }
}
export class ClientPlayerAndGameIdProvider extends Layer {
    constructor(userDataProvider) {
        super([PLAYER_ID_FIELD, CURRENT_GAME_FIELD]);
        this.userDataProvider = userDataProvider;
    }
    update(inEvent) {
        if (inEvent.key === USERNAME_FIELD || inEvent.key === DESIRED_GAME_FIELD) {
            return null;
        }
        return Object.assign(Object.assign({}, inEvent), { key: inEvent.key === CURRENT_GAME_FIELD ? 'gameId' : inEvent.key });
    }
    activate() {
    }
    close() {
    }
    getLayerData() {
        const providerData = this.userDataProvider.getLayerData();
        return {
            [PLAYER_ID_FIELD]: providerData[PLAYER_ID_FIELD],
            gameId: providerData[CURRENT_GAME_FIELD],
        };
    }
}
export class ServerPlayerAndGameIdProvider extends Layer {
    constructor(gameId) {
        super([]);
        this.gameId = gameId;
        this.playerId = "p~______";
    }
    activate() {
    }
    close() {
    }
    // No update because this is a root layer.
    update() {
        return null;
    }
    getLayerData() {
        return {
            gameId: this.gameId,
            playerId: this.playerId,
        };
    }
}
//# sourceMappingURL=UserDataLayers.js.map